import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=38acd2a7&scoped=true"
import script from "./AddAccount.vue?vue&type=script&lang=js"
export * from "./AddAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acd2a7",
  null
  
)

export default component.exports